import { render, staticRenderFns } from "./treasureTrove.vue?vue&type=template&id=6199f79f&scoped=true"
import script from "./treasureTrove.vue?vue&type=script&lang=js"
export * from "./treasureTrove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199f79f",
  null
  
)

export default component.exports